import { DefaultService } from "@/services/DefaultService";

export default class RentabilidadeService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    findAll(column, order, page, limit, situacao, ...params) {
        return this._http
            .get(
                `${
                    this._env
                }/vendas/rentabilidade.json?column=${column}&order=${order}&page=${page}&limit=${limit}&situacao=${situacao}&param=${params}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }

    updateSituacao(rentabilidade) {
        return this._http
            .post(
                `${this._env}/vendas/rentabilidade/updatesituacao`,
                rentabilidade,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }

    save(rentabilidade) {
        return this._http
            .post(
                `${this._env}/vendas/rentabilidade`,
                rentabilidade,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw err;
                }
            );
    }

    find(id) {
        return this._http
            .get(`${this._env}/vendas/rentabilidade/${id}.json`, this._headers)
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }

    findAllCombo(...params) {
        return this._http
            .get(
                `${
                    this._env
                }/vendas/rentabilidade/getcombo.json?param=${params}`,
                this._headers
            )
            .then(
                (res) => {
                    return res.body;
                },
                (err) => {
                    this.verifyError(err);
                    throw new Error("Problems while jobs are loading");
                }
            );
    }
}
